export enum CopyableUserFeedSettings {
  Connections = "connections",
  PassingComparisons = "passingComparisons",
  BlockingComparisons = "blockingComparisons",
  ExternalProperties = "externalProperties",
  RefreshRate = "refreshRate",
  DateChecks = "dateChecks",
  DatePlaceholderSettings = "datePlaceholderSettings",
}
